import React, { useEffect, useRef, useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiPause } = FiIcons;

// Reusable player: play/pause, seek bar, loops, optional fade-out.
const AudioPlayer = ({ src, title, instrument, fadeOut = false }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(0);

  useEffect(() => {
    if (!fadeOut || !ref.current) return undefined;
    const a = ref.current;
    const t = setInterval(() => {
      a.volume = Math.max(0, a.volume - 0.05);
      if (a.volume <= 0) { a.pause(); a.volume = 1; setPlaying(false); clearInterval(t); }
    }, 150);
    return () => clearInterval(t);
  }, [fadeOut]);

  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (a.paused) { a.play().catch(() => {}); setPlaying(true); } else { a.pause(); setPlaying(false); }
  };

  return (
    <div className="no-print flex items-center gap-3 bg-white border border-brand-dark rounded-xl px-3 py-2">
      <audio
        ref={ref}
        src={src}
        loop
        preload="none"
        onTimeUpdate={(e) => setTime(e.target.currentTime)}
        onLoadedMetadata={(e) => setDur(e.target.duration)}
      />
      <button type="button" onClick={toggle} className="w-8 h-8 rounded-full bg-accent-navy text-white flex items-center justify-center">
        <SafeIcon icon={playing ? FiPause : FiPlay} className="w-4 h-4" />
      </button>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold text-accent-navy truncate">{title}</p>
        <p className="text-[10px] text-text-muted">{instrument}</p>
        <input
          type="range"
          min="0"
          max={dur || 0}
          step="0.1"
          value={time}
          onChange={(e) => { if (ref.current) ref.current.currentTime = Number(e.target.value); }}
          className="w-full accent-accent-gold"
        />
      </div>
    </div>
  );
};

export default AudioPlayer;